<script>
    import { fade } from 'svelte/transition';
    import FVHero from '../components/FVHero.svelte'
    import Centering from '../layouts/Centering.svelte'
    import Floating from '../components/FloatingContent.svelte'
    import Heading from '../components/Heading.svelte'
    const src = {
        pc:"img/about-fv.png",
        mb:"img/about-fv_mb.png"
    }
    const src2 ={
        pc:"img/about-sv.png",
        mb:"img/about-sv_mb.png"
    }
</script>
<svelte:head>
	<title>会社方針 | 株式会社有倉商店</title>
</svelte:head>
<div transition:fade>
    <FVHero images={src} />
    <div class="hd-layout">
        <Centering>
            <Heading
                text={{
                    main:"POLICY",
                    sub:"会社方針"
                }}
            />
        </Centering>
    </div>
    <div class="fv-msg">
        <Centering>
            <div class="fv-content">
                <h2>
                    安心と<br>
                    安全と<br>
                    お客様の笑顔
                </h2>
                <p>
                    わたくしたち株式会社有倉商店は、管理栄養士の先生方のご協力の元で長年にわたり学校 
                    給食と病院食に青果を納めさせて頂いております。お客様の口に入る商材を取り扱っていることを常に念頭に置くとともに、
                    給食現場のニーズに合わせた青果をお届けすることにより、お客様へのお役立ちを行っております。 
                    私たちがこだわり厳選した野菜と果物で、「笑顔」と「健康」をお届けする事が私たちの使命と考えます。 
                </p>
            </div>
        </Centering>
    </div>
    <FVHero images={src2} />
    <Centering>
    <div class="about-wrapper">
        <div class="floating-negative-wrapper">
            <Floating style={{width:"1124px",height:"389px",mbWidth:"100%",mbHeight:"480px"}}>
                <div class="floating-inner floating-inner-first">
                    <h3>お客様の口に入る商材を取り扱っていますので、<br>
                        弊社では下記の衛生管理の実施と保健所との取組を行っております。</h3>
                    <p>・(株)有倉商店本社<br>
                    江東区保健所に営業届提出済み（整理番号NIF20210000004299）</p>
                    <p>・(株)有倉商店市川支社<br>
                        市川健康福祉センターに営業届提出済み（整理番号NIF20210000004489）</p>
                </div>
            </Floating>
            <Floating style={{width:"1124px",height:"500px",mbWidth:"100%",mbHeight:"730px"}}>
                <div class="floating-inner floating-inner-second">
                    <div>
                        <h3><span class="emphasize">1.</span>HACCPの考え方を取り入れた<br/>
                            衛生管理を実施 </h3>
                            <p>
                                ・従業員大便検査の実施<br>
                                ・手洗/消毒/ローラー掛け/帽子着用実施のチェック管理<br>
                                ・出社時検温及び健康チェック管理<br>
                                ・全冷蔵設備の温度管理 <br>
                                ・各作業場の清掃チェック管理<br>
                                ・定期的な害虫駆除<br>
                                ・下処理野菜の金属探知機管理(真空商品)
                            </p>
                    </div>
                    <img src="img/floating-1.png" alt="" />
                </div>
            </Floating>
            <div class="floating-row">
                <Floating style={{width:"520px",height:"599px",mbWidth:"100%",mbHeight:"480px"}}>
                    <div class="floating-inner floating-inner-third">
                            <h3><span class="emphasize">2.</span> 保健所「食品衛生監視票」<br>
                                チェックにおいて 91 点取得 </h3>
                        <img src="img/floating-2.png" alt="" />
                    </div>
                </Floating>
                <Floating style={{width:"520px",height:"599px",mbWidth:"100%",mbHeight:"480px"}}>
                    <div class="floating-inner floating-inner-third">
                        <h3><span class="emphasize">3.</span>東京都食品衛生自主管理認証制度<br>
                            「エントリーステージ」以上 </h3>
                        <span class="mini">※基本のコースは全てクリア </span>   
                        <img src="img/floating-3.png" alt="" />
                    </div>
                </Floating>

            </div>
        </div>
    </div>
    </Centering>

</div>


<style>
    .hd-layout{
        margin-top: 70px;
        margin-bottom: 70px;
    }
    .fv-msg{
        display: flex;
        width: 100%;
        background-color: #fff;
        height: 460px;
        margin-bottom: 50px;
    }
    .fv-content{
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .fv-content h2{
        display: inline-flex;
        width: 360px;
        height: 270px;
        font-family: "Noto Sans JP",sans-serif;
        font-weight: normal;
        font-size: 60px;
        text-align: left;
        color: #000;
    }
    .fv-content p{
        font-family: "Noto Sans JP",sans-serif;
        font-weight: normal;
        font-size: 16px;
        line-height: 36px;
        text-align: left;
        color: #000;
        width: 602px;
    }
    .about-wrapper{
        position:relative;
        padding-bottom:1598px;
    }
    .floating-negative-wrapper{
        margin-top:-50px;position:absolute;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height:1598px;
    }
    .floating-inner-first{
        margin-top: 50px;
        margin-left: 60px;
        margin-bottom: 30px;
    }
    h3{
        font-family: "Noto Sans JP",sans-serif;
        font-weight: normal;
        font-size: 24px;
        line-height: 41px;
        text-align: left;
        color: #000;
        margin-bottom: 60px;
        margin-top: 0;
    }
    h3:after{
        content:"";
        display: block;
        height:3px;
        width:46px;
        background-color: #FF9B11;
        margin-top: 10px;
    }
    .floating-inner-first p{
        margin-bottom: 40px;
        font-family: "Noto Sans JP",sans-serif;
        font-weight: normal;
        font-size: 16px;
        text-align: left;
        color: #000;

    }
    .floating-inner-second {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }
    .floating-inner-second div{
        margin-top: 50px;
        margin-left: 60px;
        margin-bottom: 30px;
        display: flex;
        flex-direction: column;
    }

    .floating-inner-second p{
        margin-bottom: 40px;
        font-family: "Noto Sans JP",sans-serif;
        
        font-size: 16px;
        text-align: left;
        color: #000;

    }
    .floating-inner-third{
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        justify-content: space-between;
    }
    .floating-inner-third h3{
        margin-left: 60px;
        margin-top: 40px;
        margin-bottom: 0px;
    }
    .mini{
        font-family: "Noto Sans JP",sans-serif;
        -webkit-font-smoothing: antialiased;
        font-weight: normal;
        font-size: 14px;
        line-height: 36px;
        text-align: left;
        color: #000;
        margin-top: 0px;
        margin-left: 60px;
    }
    .emphasize{
        color: #FF9B11
    }
    .floating-row{
        display:flex;
        width: 100%;
        justify-content: space-between;
    }
    .about-wrapper{
        margin-bottom: 125px;
    }
    @media screen and (max-width:640px){
        .fv-content{
            flex-direction: column;
            height:auto;
            width: 100%;
        }
        .fv-msg{
            height:auto; 
        }

        .fv-content h2{
            font-size: 40px;
            margin: 60px 0;
            width: 100%;
            height: auto;
        }
        .fv-content p{
            width: 100%;
            font-size: 14px;
            line-height: 36px;
            padding-bottom: 50px;
        }
        .floating-row{
            flex-direction: column;
        }
        .floating-inner img{
            width: 100%;
        }
        .about-wrapper{
            width: 100%;
            padding-bottom: 2500px;
            margin-bottom: 125px;
        }
        .floating-negative-wrapper{
            height:2500px;
        }
        .floating-inner-first{
            margin:30px 15px;
        }
        .floating-inner-first h3{
            font-size: 16px;
            line-height: 36px;
        }
        .floating-inner-second{
            flex-direction: column;
        }
        .floating-inner-second div{
            margin:30px 15px;
        }
        .floating-inner-second h3{
            font-size: 16px;
            line-height: 36px;
        }
        .floating-inner-third img{
            height: 275px;
        }
        .floating-row{
            flex-direction: column;
            height: 1000px;
            justify-content: space-between;
        }
        .mini{
            margin-left: 15px;
        }
        .floating-row h3{
            font-size: 16px;
            line-height: 36px;
            margin-left: 15px;
            margin-top: 30px;
        }
        .floating-mt{
            margin-top: -60px;
        }
    }
</style>